import React from 'react';

import { OverlayTrigger, Popover } from 'react-bootstrap';
import {
  NO_FOUND,
  NO_PERFECT_MATCH,
} from 'shared/product_tabs/tab_parts/data/BomLineItemStatus';

const getAlertVariant = (has_error, show_qty_price) => {
  if (has_error) return 'danger';
  if (!show_qty_price) return 'secondary';
  return 'success';
};

const Stock = (props) => {
  const {
    quote_status,
    status,
    row,
    exact_qty,
    extra_parts,
    stock,
    qty_to_buy,
    has_error,
    show_qty_price,
  } = props;

  if (
    quote_status === 'pending' ||
    status === NO_FOUND ||
    status === NO_PERFECT_MATCH
  )
    return <span>-</span>;

  const order_qty = exact_qty + extra_parts;
  const alert_variant = getAlertVariant(has_error, show_qty_price);

  if (!has_error && !show_qty_price) {
    return (
      <div className="d-flex justify-content-center">
        <div
          className={`bom-stock ${alert_variant} d-flex justify-content-center align-items-center`}>
          <span>-</span>
        </div>
      </div>
    );
  }

  const popover = (
    <Popover id={`bli-stock-popover-${row}`} className="w-50">
      <Popover.Title as="h3" />
      <Popover.Content>
        <span
          className={`text-${stock > 0 && stock < order_qty ? 'warning' : alert_variant}`}>
          {stock === 0 && 'OUT OF STOCK'}
          {stock > 0 && stock < order_qty && 'NOT ENOUGH STOCK'}
          {stock >= order_qty && `${stock} (IN STOCK)`}
        </span>
        {stock > 0 && (
          <div className="row">
            <div className="col-8">Exact Qty:</div>
            <div className="col-4 text-end">{exact_qty}</div>
            <div className="col-8">Extra Parts:</div>
            <div className="col-4 text-end border-bottom">
              {extra_parts}
            </div>
            <div className="col-8">
              {stock < order_qty ? 'Required' : 'Order'} Qty:
            </div>
            <div className="col-4 text-end">{exact_qty + extra_parts}</div>
            {stock < order_qty && (
              <>
                <div className="col-8">Available Stock:</div>
                <div className="col-4 text-end">{stock}</div>
              </>
            )}
          </div>
        )}
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={popover}>
      <div className="d-flex justify-content-center">
        <div
          className={`bom-stock ${alert_variant} d-flex justify-content-between align-items-center`}>
          <span>{show_qty_price ? qty_to_buy : 'Select'}</span>
          <span>
            <div className="icon-block d-flex justify-content-center align-items-center">
              <img src={Spree.image_assets.info_icon_01} alt="Info Icon" />
            </div>
          </span>
        </div>
      </div>
    </OverlayTrigger>
  );
};

export default Stock;
